import { gql } from '@apollo/client';

import { TTariffGridItem } from 'types';

export interface ITariffGridRequest {
  input: {
    host_id?: number;
    client_uuid?: string;
    shift?: number;
  };
}
export interface ITariffGridResponse {
  tariffGrid: Array<TTariffGridItem>;
}
export const TARIFF_GRID = gql`
  query tariffGrid($input: TariffGridInput!) {
    tariffGrid(input: $input) {
      id
      title
      duration
      cost
      time_from
      time_to
      use_global_discounts
      has_fixed_finish_time
      per_minute
      pausable
      booked
      disable_sale_receipt_printing
    }
  }
`;
